<template>
    <div class="forms__field_input--select-icon">
        <div
            v-for="option in props.options"
            :key="option"
            class="forms__field_input--select-icon__icon"
            :class="[{ 'forms__field_input--select-icon__icon--selected': modelValue === option.id }]"
            @click="modelValue = option.id"
        >
            <img
                :src="`${option.img ?? option.id}`"
                class="forms__field_input--select-icon__icon-preview dark:invert"
                :alt="option.id"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { FieldComponent } from '@src/Common/Components/types';

const modelValue = defineModel({
    type: String,
});

const props = withDefaults(defineProps<FieldComponent>(), {
    options: () => [],
});
</script>
